import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import orderServices from "../../services/orders/orderservice";

interface CollectedAmountTraceDatatableProps {
  visible: boolean;
  onHide: () => void;
  userID: number;
  userName: string;
  startDate: string;
  endDate: string;
}

const CollectedAmountTraceDatatable: React.FC<CollectedAmountTraceDatatableProps> = ({
  visible,
  onHide,
  userID,
  userName,
  startDate,
  endDate
}) => {
  const [loading, setLoading] = useState(false);
  const [collectionData, setCollectionData] = useState<any[]>([]);

  useEffect(() => {
    if (!visible) return;

    const fetchCollectionData = async () => {
      setLoading(true);
      debugger
      try {
        const response = await orderServices.cashandOnlineList({
          dateFilter: {
            startDate: new Date(startDate),
            endDate: new Date(endDate),
            userId: userID,
            collectionType: 1
          }
        });

        setCollectionData(response?.collectionList || []);
      } catch (error) {
        console.error("Error fetching collection data:", error);
        setCollectionData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCollectionData();
  }, [visible, userID, startDate, endDate]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  return (
    <Dialog
      header={`Collected Amount Details - ${userName}`}
      visible={visible}
      onHide={onHide}
      style={{ width: "80vw" }}
      modal
    >
      <DataTable
        value={collectionData}
        loading={loading}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50, 100]}
        emptyMessage="No collection data found"
        stripedRows
        showGridlines
        sortMode="multiple"
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
         <Column field="orderID" header="Order #" sortable/>
        <Column field="invoiceNo" header="Invoice #" sortable/>
        <Column field="invoiceDate" header="Invoice Date" sortable body={(rowData) => formatDate(rowData.invoiceDate)}/>
        <Column field="courierCharges" header="Courier Charges" sortable/>
        <Column field="handlingCharges" header="Handling Charges" sortable/>
        <Column field="paymentGatewayCharges" header="PaymentGateway Charges" sortable/>
        <Column field="discountAmount" header="Discount Amount" sortable/>
        <Column field="grossAmount" header="Gross Amount" sortable/>
      </DataTable>
    </Dialog>
  );
};

export default CollectedAmountTraceDatatable;
